import { render, staticRenderFns } from "./PriceIcon.vue?vue&type=template&id=4927c8f3&scoped=true&"
import script from "./PriceIcon.vue?vue&type=script&lang=js&"
export * from "./PriceIcon.vue?vue&type=script&lang=js&"
import style0 from "./PriceIcon.vue?vue&type=style&index=0&id=4927c8f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4927c8f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
